import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'


import logo_inicio from '../images/logo-inicio.png'

import solucion_humedades from '../images/inicio-soluciones/humedades.jpg'
import solucion_morteros from '../images/inicio-soluciones/morteros-tecnicos.jpg'
import solucion_decoracion from '../images/inicio-soluciones/decoracion.jpg'
import solucion_pintura from '../images/inicio-soluciones/pintura.jpg'

import logo_kerakoll from '../images/logos/kerakoll.png'
import logo_topciment from '../images/logos/topciment.png'
import logo_fassa from '../images/logos/fassa-bortolo.png'
import logo_artecontinuo from '../images/logos/arte-continuo.png'
import logo_newtiles from '../images/logos/new-tiles.png'

const IndexPage = () => (
    <div>
        <Helmet>
            <title>Inicio</title>
        </Helmet>

        <div className="index-hero">
            <div className="container">
                <img
                    src={logo_inicio}
                    className="logo-inicio"
                />
                <h1 className="hero-text customFadeInDown">
                    Calidad y detalle en todo tipo de revestimientos continuos, ya sea cal o
                    cemento, en interior o exterior, incluso bajo el agua.
                </h1>
            </div>
        </div>

        <div className="features-section">
            <div className="container">
                <div className="header text-center soluciones-header">
                    <h2>Nuestras soluciones técnicas</h2>
                    <p className="mt-3">
                        Soluciones profesionales de nivel técnico a los problemas
                        más comunes en viviendas y locales
                    </p>
                </div>
                <div className="feature">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="info">
                                <Link to="/soluciones-tecnicas/humedades">
                                    <h4 className="mt-lg-5">Humedades</h4>
                                </Link>
                                <p>
                                    Encuentra la solución adecuada a tiempo y no malgaste tu dinero,
                                    tenemos la solución definitiva tanto para filtraciones,
                                    impermeabilizaciones, remonte capilar y mas...
                                </p>
                                <Link className="btn btn-primary d-none d-sm-inline" to="/soluciones-tecnicas/humedades">
                                    Ver soluciones
                                </Link>
                            </div>
                        </div>
                        <div className="col-md-6 text-center">
                            <Link to="/soluciones-tecnicas/humedades">
                                <img src={solucion_humedades} className="img-fluid" />
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="divider"></div>
                <div className="feature">
                    <div className="row">
                        <div className="col-md-6 order-md-2">
                            <div className="info">
                                <Link to="/soluciones-tecnicas/morteros-tecnicos">
                                    <h4 className="mt-lg-5">Morteros Tecnicos</h4>
                                </Link>
                                <p>
                                    Tiene problema estructurales en su vivienda. ¡No se preocupe!...
                                    Si existe la solución, nosotros la tenemos.
                                </p>
                                <Link className="btn btn-primary d-none d-sm-inline" to="/soluciones-tecnicas/morteros-tecnicos">
                                    Ver soluciones
                                </Link>
                            </div>
                        </div>
                        <div className="col-md-6 order-md-1 text-center">
                            <Link to="/soluciones-tecnicas/morteros-tecnicos">
                                <img src={solucion_morteros} className="img-fluid" />
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="divider"></div>
                <div className="feature">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="info">
                                <Link to="/soluciones-tecnicas/decoracion">
                                    <h4 className="mt-lg-5">Decoración</h4>
                                </Link>
                                <p>
                                    Para todos los gustos…texturas y colores, pavimentos, paredes,
                                    mobiliario, a cualquier cosa que se te ocurra, dale ese toque
                                    especial, singular y propio.
                                </p>
                                <Link className="btn btn-primary d-none d-sm-inline" to="/soluciones-tecnicas/decoracion">
                                    Ver soluciones
                                </Link>
                            </div>
                        </div>
                        <div className="col-md-6 text-center">
                            <Link to="/soluciones-tecnicas/decoracion">
                                <img src={solucion_decoracion} className="img-fluid" />
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="divider"></div>
                <div className="feature">
                    <div className="row">
                        <div className="col-md-6 order-md-2">
                            <div className="info">
                                <Link to="/soluciones-tecnicas/pintura">
                                    <h4 className="mt-lg-5">Pintura</h4>
                                </Link>
                                <p>
                                    Protección y decoración: Amplia gama en pinturas de exterior
                                    e interior... Transpirables lavables y ecológica amplia
                                    gama cromática en todas nuestras líneas de acabados.
                                </p>
                                <Link className="btn btn-primary d-none d-sm-inline" to="/soluciones-tecnicas/pintura">
                                    Ver soluciones
                                </Link>
                            </div>
                        </div>
                        <div className="col-md-6 order-md-1 text-center">
                            <Link to="/soluciones-tecnicas/pintura">
                                <img src={solucion_pintura} className="img-fluid" />
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        {/* <div className="testimonials-section">
            <div className="container">
                <h3 className="header">
                    Testimonios
                </h3>
                <div className="row">
                    <div className="col-md-6">
                        <div className="testimonial">
                            <div className="quote">
                                tiam pellentesque semper ipsum quis sollicitudin. Phasellus efficitur feugiat enim
                                vel aliquet. In vel sagittis massa. Morbi mattis pulvinar ornare. In maximus risus purus.
                                <div className="arrow-down">
                                    <div className="arrow"></div>
                                    <div className="arrow-border"></div>
                                </div>
                            </div>
                            <div className="author">
                                <img src="https://via.placeholder.com/71x71" className="pic" alt="testimonial3" />
                                <div className="name">John McClane</div>
                                <div className="company">lorem itsum</div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="testimonial">
                            <div className="quote">
                                Lorem ipsum dolor sit amet, consectetur  quis sollicitudin. Phasellus efficitur feugiat enim
                                vel aliquet. In vel sagittis massa. Morbi mattis pulvinar ornare. In maximus risus purus.
                                <div className="arrow-down">
                                    <div className="arrow"></div>
                                    <div className="arrow-border"></div>
                                </div>
                            </div>
                            <div className="author">
                                <img src="https://via.placeholder.com/71x71" className="pic" alt="testimonial2" />
                                <div className="name">Carl Jones</div>
                                <div className="company">tiam pellentesque</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> */}

        <div className="clients-section">
            <div className="container">
                <h3>Empresas colaboradoras</h3>
                <div className="logos">
                    <img src={logo_kerakoll} />
                    <img src={logo_topciment} />
                    <img src={logo_newtiles} />
                    <img src={logo_fassa} />
                    <a href="https://www.artecontinuo.com/" target="_blank" rel="noopener">
                        <img src={logo_artecontinuo} />
                    </a>
                </div>
            </div>
        </div>
    </div>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js